<div class="customers">
    <div class="row">
        <div class="col-sm-12">
            <div class="divDimension">
                <div class="row">
                    <div class="col-sm-1" [ngClass]="'color-back-area-' + dimensionData.orden" *ngIf="isCollapsed" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;color: antiquewhite;">
                        <p style="padding: 20px;margin-left: 25px;font-weight: bold;">{{dimensionData.orden}}</p>
                    </div>
                    <div class="col-sm-1" [ngClass]="'color-back-area-' + dimensionData.orden" *ngIf="!isCollapsed" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                    color: antiquewhite;">
                        <p style="padding: 20px;margin-left: 25px;font-weight: bold;">{{dimensionData.orden}}</p>
                    </div>
                    <div class="col-sm-10">
                        <p class="dataFecha" style="margin: 20px;">Dimensión {{dimensionData.dimension}}</p>
                    </div>
                    <div class="col-sm-1">
                        <button class="btn-collapser" style="margin: 10px;" [ngClass]="'color-area-' + dimensionData.orden" *ngIf="isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                        <button class="btn-collapser" style="margin: 10px;" [ngClass]="'color-area-' + dimensionData.orden" *ngIf="!isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                    </div>
                    <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" style="padding: 10px;">
                        <div *ngFor="let subdimenson of dimensionData?.subdimensiones; let indice=index">
                            <app-ins-autoevaluacion-subdimension [subDimension]="subdimenson" [readonly]="simulacion" [isModificable]="isModificable"></app-ins-autoevaluacion-subdimension>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>